import { Drawer, Spin, Tabs } from "antd";
import { getNationalRanking, getStudentRanking, getStudentSchoolRanking } from "api/services/studentQuizz/studentQuizz.services";
/* import belgiumFlag from "assets/images/app/belgium-flag.png"; */
/* import frenchFlag from "assets/images/app/french-flag.png"; */
/* import moroccoFlag from "assets/images/app/morocco-flag.png"; */
import { useEffect, useRef, useState } from "react";
import ArrowBack from "../../assets/images/app/arrow_back.svg";
import dollarCoins from "../../assets/images/app/dollar-coins.png";
import schoolPic from "../../assets/images/app/school.svg";
import Student from "../../assets/images/students/student.svg";
import st from "./style.module.css";

const { TabPane } = Tabs;

type Props = {
    visible: boolean,
    onClose: () => void,
    user: any,
    type: any,
}

const RankingDrawer: React.FC<Props> = ({ visible, onClose, user, type }) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
    const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
    const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
        setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
        setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
        setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
        setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
    };
    window.addEventListener('resize', handleResize);

    const [rankingData, setRankingData] = useState<any>([]);
    const [schoolRankingData, setSchoolRankingData] = useState<any>([]);
    const [nationalRankingData, setNationalRankingData] = useState<any>([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [userExist, setUserExist] = useState<boolean>(false);
    const [displayUser, setDisplayUser] = useState<boolean>(true);

    const [currentTab, handleTabChange] = useState<string>("1");
    const [currentPage, setCurrentPage] = useState<number>(1);

    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const controllerRef = useRef<AbortController | null>(null);
    const schoolControllerRef = useRef<AbortController | null>(null);
    const nationalControllerRef = useRef<AbortController | null>(null);

    const closeDrawer = async () => {
        setRankingData([]);
        setSchoolRankingData([]);
        setTotalPages(1);
        setUserExist(false);
        setDisplayUser(false);
        setPage(1);
        setLoading(false);
        setHasMore(true);
        handleTabChange("1");
        onClose();
    }

    const fetchStudentData = async () => {

        // Cancel any ongoing request before starting a new one
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;

        const timeoutId = setTimeout(() => controller.abort(), 5000);

        try {
            if (page <= totalPages) {
                setLoading(true);

                const res = await getStudentRanking(user?._id, page, controller.signal);
                clearTimeout(timeoutId);

                if (!res) return;

                const data = res?.data?.results;
                const pages = res?.data?.totalPages;
                const userExist = res?.data?.userExist;
                ///const newData = data.map((element: any) => element.user);
                setTotalPages(pages);
                setUserExist(userExist);

                setRankingData((prevData: any) => [...prevData, ...data]);

                if (page === pages) {
                    setHasMore(false);
                }
                else {
                    setHasMore(true);
                }
            }

        } catch (error: any) {
            if (error.name === "AbortError") {
                console.log("Request timed out after 10 seconds");
            } else {
                console.error("Error fetching national data:", error);
            }
        } finally {
            clearTimeout(timeoutId);
            setLoading(false);
        }
    };

    const fetchSchoolData = async () => {

        // Cancel any ongoing request before starting a new one
        schoolControllerRef.current?.abort();
        const controller = new AbortController();
        schoolControllerRef.current = controller;

        const timeoutId = setTimeout(() => controller.abort(), 5000);

        try {
            if (page <= totalPages) {
                setLoading(true);

                const res = await getStudentSchoolRanking(user?._id, page, controller.signal);
                clearTimeout(timeoutId);

                if (!res) return;

                const newData = res?.data?.results;
                const pages = res?.data?.totalPages;
                const userExist = res?.data?.userExist;
                setTotalPages(pages);
                setUserExist(userExist);

                setSchoolRankingData((prevData: any) => [...prevData, ...newData]);

                if (page === pages) {
                    setHasMore(false);
                }
                else {
                    setHasMore(true);
                }
            }

        } catch (error: any) {
            if (error.name === "AbortError") {
                console.log("Request timed out after 10 seconds");
            } else {
                console.error("Error fetching national data:", error);
            }
        } finally {
            clearTimeout(timeoutId);
            setLoading(false);
        }
    };

    const fetchNationalData = async () => {

        // Cancel any ongoing request before starting a new one
        nationalControllerRef.current?.abort();
        const controller = new AbortController();
        nationalControllerRef.current = controller;

        const timeoutId = setTimeout(() => controller.abort(), 5000);

        try {
            if (page <= totalPages) {
                setLoading(true);

                const res = await getNationalRanking(user?._id, page, controller.signal);
                clearTimeout(timeoutId);

                if (!res) return;

                const data = res?.data?.results;
                const pages = res?.data?.totalPages;
                const userExist = res?.data?.userExist;
                ///const newData = data.map((element: any) => element.user);
                setTotalPages(pages);
                setUserExist(userExist);

                setNationalRankingData((prevData: any) => [...prevData, ...data]);

                if (page === pages) {
                    setHasMore(false);
                }
                else {
                    setHasMore(true);
                }
            }

        } catch (error: any) {
            if (error.name === "AbortError") {
                console.log("Request timed out after 10 seconds");
            } else {
                console.error("Error fetching national data:", error);
            }
        } finally {
            clearTimeout(timeoutId);
            setLoading(false);
        }
    };

    const switchSchoolData = async (tabIndex: string) => {
        setRankingData([]);
        setSchoolRankingData([]);
        setTotalPages(1);
        setUserExist(true);
        setDisplayUser(false);
        setPage(1);
        setLoading(true);
        setHasMore(true);
    }

    useEffect(() => {
        const containerElement = document.querySelector('.ant-drawer-body');

        const handleScroll = () => {
            if (containerElement && visible) {
                const { scrollTop, scrollHeight, clientHeight } = containerElement;
                if (scrollTop + clientHeight >= scrollHeight && !loading && hasMore) {
                    setPage((prevPage) => prevPage + 1);
                }
            }
        };

        if (containerElement && visible) {
            containerElement.addEventListener('scroll', handleScroll);

            return () => {
                containerElement.removeEventListener('scroll', handleScroll);
            };
        }
    }, [visible, loading, hasMore]);

    useEffect(() => {
        if (currentPage === 1) {
            setUserExist(false);
            setDisplayUser(false);
            fetchStudentData();
        }
        else if (currentPage === 2) {
            fetchSchoolData();
        }
        else {
            fetchNationalData();
        }
    }, [page]);

    // Reset page to 1 when the drawer is opening
    useEffect(() => {
        if (visible) {
            setPage(1);
            setUserExist(false);
            setDisplayUser(false);
            setRankingData([]);
            setSchoolRankingData([]);
            setNationalRankingData([]);
            fetchStudentData();
            fetchSchoolData();
            fetchNationalData();
        } else {
            // cancel request when drawer closes
            controllerRef.current?.abort();
            schoolControllerRef.current?.abort();
            nationalControllerRef.current?.abort();
        }
    }, [visible]);

    // Reset page to 1 when the component is unmounted
    useEffect(() => {
        return () => {
            setPage(1);
        };
    }, []);

    useEffect(() => {
        if (userExist) {
            setDisplayUser(false);
        }
    }, [userExist]);

    return (
        <div>
            <Drawer
                className="drawer"
                placement="left"
                closable={true}
                onClose={closeDrawer}
                visible={visible}
                width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "55%" : isMediumScreen ? "50%" : isNormalScreen ? "45%" : "40%"}
                title={
                    <div style={{ fontSize: isMobile ? "12px" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>Mes classements <img src={schoolPic} height={20} style={{ marginLeft: "10px" }}></img></div>
                    </div>
                }
                headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
                closeIcon={
                    <img
                        src={ArrowBack}
                        height={isMobile ? 12 : 18}
                        style={{}}
                    ></img>
                }
                drawerStyle={{ backgroundColor: "#FFF", borderTopRightRadius: isMobile ? "0px" : "30px", borderBottomRightRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", height: "auto", width: "auto", marginLeft: "40px" }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", height: "auto", width: "100%", gap: "15px" }}>
                        <div onClick={() => setCurrentPage(1)} className={st.tabButton} style={{ color: currentPage === 1 ? "#7FB1B2" : "#868686", border: currentPage === 1 ? "1px solid #7FB1B2" : "1px solid #BFBCBC81", boxShadow: currentPage === 1 ? "6px 8px 14px #7FB1B238" : "2px 4px 8px #CECECE29" }}>Mon classement<br />en établissement</div>
                        <div onClick={() => setCurrentPage(2)} className={st.tabButton} style={{ color: currentPage === 2 ? "#7FB1B2" : "#868686", border: currentPage === 2 ? "1px solid #7FB1B2" : "1px solid #BFBCBC81", boxShadow: currentPage === 2 ? "6px 8px 14px #7FB1B238" : "2px 4px 8px #CECECE29" }}>Classement de<br />mon établissement</div>
                        <div onClick={() => setCurrentPage(3)} className={st.tabButton} style={{ color: currentPage === 3 ? "#7FB1B2" : "#868686", border: currentPage === 3 ? "1px solid #7FB1B2" : "1px solid #BFBCBC81", boxShadow: currentPage === 3 ? "6px 8px 14px #7FB1B238" : "2px 4px 8px #CECECE29" }}>Classement <br />national ({user?.pays})</div>
                    </div>

                </div>

                {currentPage === 1 && <div style={{ marginTop: "20px" }}>
                    {/* Display the content for the first tab */}
                    <ul className="ant-drawer-body" style={{ padding: "0px" }}>
                        {/* Display user ranking only */}
                        {!loading && rankingData.length === 0 && <li style={{ position: "absolute", top: "100px", left: "5%", right: "5%" }}>
                            <div className={st.currentUserBox}>
                                <div className={st.userNavInfoLeft}>
                                    <div className={st.left}>
                                        {user.rankEtab}
                                        <span className={st.rankInfo}>{user.rankEtab === 1 ? "er" : "e"}</span>
                                    </div>
                                </div>
                                <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <div style={{ background: "#FFEDD5", borderRadius: "50%" }}>
                                        <img src={user?.profile} height={55} style={{ borderRadius: "50%" }}></img>
                                    </div>
                                    <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                        <span className={st.userName}>{user?.firstname + " " + user?.lastname}</span>
                                    </div>
                                </div>
                                <div className={st.userNavInfoRight}>
                                    <div className={st.right}>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            {user?.score}
                                            <span className={st.classementInfo}>PTS</span>
                                        </div>
                                        <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                    </div>
                                </div>
                            </div>
                        </li>}
                        {/* Display the ranking data */}
                        {!loading && rankingData.length > 0 && rankingData.map((item: any, index: any) => {
                            return (<li key={index}>
                                <div className={item?._id === user?._id ? st.currentUserBox : st.userBox}>
                                    <div className={st.userNavInfoLeft}>
                                        <div className={st.left}>
                                            {item?.rankEtab}
                                            <span className={st.rankInfo}>{item?.rankEtab === 1 ? "er" : "e"}</span>
                                        </div>
                                    </div>
                                    <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ background: "#FFEDD5", borderRadius: "50%", marginRight: "5px" }}>
                                            <img src={item?.profile || Student} height={55} style={{ borderRadius: "50%" }}></img>
                                        </div>
                                        <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                            <span className={st.userName}>{item?.firstname.charAt(0).toUpperCase() + item?.firstname.slice(1).toLowerCase()}{" "}{item?.lastname.charAt(0).toUpperCase() + item?.lastname.slice(1).toLowerCase()}</span>
                                        </div>
                                    </div>
                                    <div className={st.userNavInfoRight}>
                                        <div className={st.right}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                {item?.score}
                                                <span className={st.classementInfo}>PTS</span>
                                            </div>
                                            <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                        </div>
                                    </div>
                                </div>
                            </li>)
                        })}
                        {/* Display user ranking only under */}
                        {displayUser && !loading && rankingData.length !== 0 && <li style={{ position: "absolute", bottom: "30px", left: "5%", right: "5%" }}>
                            <div className={st.currentUserBox}>
                                <div className={st.userNavInfoLeft}>
                                    <div className={st.left}>{user.rankEtab}
                                        <span className={st.rankInfo}>{user.rankEtab === 1 ? "er" : "e"}</span>
                                    </div>
                                </div>
                                <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <div style={{ background: "#FFEDD5", borderRadius: "50%", marginRight: "5px" }}>
                                        <img src={user?.profile} height={55} style={{ borderRadius: "50%" }}></img>
                                    </div>
                                    <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                        <span className={st.userName}>{user?.firstname + " " + user?.lastname}</span>
                                    </div>
                                </div>
                                <div className={st.userNavInfoRight}>
                                    <div className={st.right}>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            {user?.score}
                                            <span className={st.classementInfo}>PTS</span>
                                        </div>
                                        <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                    </div>
                                </div>
                            </div>
                        </li>}
                        {loading && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}><Spin size="large" /></div>}
                    </ul>
                </div>}

                {currentPage === 2 && <div style={{ marginTop: "20px" }}>
                    {/* Display the content for the second tab */}
                    <ul className="ant-drawer-body" style={{ padding: "0px" }}>
                        {!loading && schoolRankingData.map((item: any, index: any) => (
                            <li key={index}>
                                <div className={st.userBox}>
                                    <div className={st.userNavInfoLeft}>
                                        <div className={st.left}>
                                            {item?.rank}
                                            <span className={st.rankInfo}>{item?.rank === 1 ? "er" : "e"}</span>
                                        </div>
                                    </div>
                                    <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                            <span className={st.userName}>{item?.name.charAt(0).toUpperCase() + item?.name.slice(1).toLowerCase()}</span>
                                        </div>
                                    </div>
                                    <div className={st.userNavInfoRight}>
                                        <div className={st.right}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                {item?.score}
                                                <span className={st.classementInfo}>PTS</span>
                                            </div>
                                            <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                        {loading && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}><Spin size="large" /></div>}
                    </ul>
                </div>}

                {currentPage === 3 && <div style={{ marginTop: "20px" }}>
                    <ul className="ant-drawer-body" style={{ padding: "0px" }}>
                        {/* Display user ranking only */}
                        {!loading && nationalRankingData.length === 0 && <li style={{ position: "absolute", top: "70px", left: "5%", right: "5%" }}>
                            <div className={st.currentUserBox}>
                                <div className={st.userNavInfoLeft}>
                                    <div className={st.left}>{user.rankNational}
                                        <span className={st.rankInfo}>{user.rankNational === 1 ? "er" : "e"}</span>
                                    </div>
                                </div>
                                <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <div style={{ background: "#FFEDD5", borderRadius: "50%", marginRight: "5px" }}>
                                        <img src={user?.profile} height={55} style={{ borderRadius: "50%" }}></img>
                                    </div>
                                    <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                        <span className={st.userName}>{user?.firstname + " " + user?.lastname}</span>
                                    </div>
                                </div>
                                <div className={st.userNavInfoRight}>
                                    <div className={st.right}>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            {user?.score}
                                            <span className={st.classementInfo}>PTS</span>
                                        </div>
                                        <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                    </div>
                                </div>
                            </div>
                        </li>}
                        {/* Display the ranking data */}
                        {!loading && nationalRankingData.map((item: any, index: any) => (
                            <li key={index}>
                                <div className={item?._id === user?._id ? st.currentUserBox : st.userBox}>
                                    <div className={st.userNavInfoLeft}>
                                        <div className={st.left}>{item?.rankNational}
                                            <span className={st.rankInfo}>{item?.rankNational === 1 ? "er" : "e"}</span>
                                        </div>
                                    </div>
                                    <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div style={{ background: "#FFEDD5", borderRadius: "50%", marginRight: "5px" }}>
                                            <img src={item?.profile} height={55} style={{ borderRadius: "50%" }}></img>
                                        </div>
                                        <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                            <span className={st.userName}>{item?.firstname.charAt(0).toUpperCase() + item?.firstname.slice(1).toLowerCase()}{" "}{item?.lastname.charAt(0).toUpperCase() + item?.lastname.slice(1).toLowerCase()}</span>
                                        </div>
                                    </div>
                                    <div className={st.userNavInfoRight}>
                                        <div className={st.right}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                {item?.score}
                                                <span className={st.classementInfo}>PTS</span>
                                            </div>
                                            <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                        {/* Display user ranking only under */}
                        {displayUser && !loading && nationalRankingData.length !== 0 && nationalRankingData.length > 16 && <li style={{ position: "absolute", bottom: "30px", left: "5%", right: "5%" }}>
                            <div className={st.currentUserBox}>
                                <div className={st.userNavInfoLeft}>
                                    <div className={st.left}>{user.rankNational}
                                        <span className={st.rankInfo}>{user.rankNational === 1 ? "er" : "e"}</span>
                                    </div>
                                </div>
                                <div style={{ height: "70px", width: "80%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <div style={{ background: "#FFEDD5", borderRadius: "50%", marginRight: "5px" }}>
                                        <img src={user?.profile} height={55} style={{ borderRadius: "50%" }}></img>
                                    </div>
                                    <div style={{ height: "70px", display: "flex", flexDirection: "column", marginLeft: "5px", color: "#FFF", alignItems: "start", justifyContent: "center", width: "90%" }}>
                                        <span className={st.userName}>{user?.firstname + " " + user?.lastname}</span>
                                    </div>
                                </div>
                                <div className={st.userNavInfoRight}>
                                    <div className={st.right}>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            {user?.score}
                                            <span className={st.classementInfo}>PTS</span>
                                        </div>
                                        <img src={dollarCoins} height={isMobile ? 10 : 15}></img>
                                    </div>
                                </div>
                            </div>
                        </li>}
                        {loading && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}><Spin size="large" /></div>}
                    </ul>
                </div>}
            </Drawer>
        </div>
    );

};

export default RankingDrawer;